import Avatar from "@material-ui/core/Avatar";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import Spinner from "components/spinner";
import React from "react";
import "./styles.scss";
const EventCard = ({ loading, membersData, name, numberOfMembers, onclick }) => {
  const [openModel, setOpenModel] = React.useState(false);
  const [openAddModel, setOpenAddModel] = React.useState(false);
  // const [loading, setLoading] = React.useState(false);

  const style = {
    margin: "0px auto",
    color: "#2555ef",
  };

  return (
    <div className="eventCard mb-5" onClick={onclick}>
      <div className="hover-border" />
      <div className="d-flex justify-content-center align-items-center h-100">
        {loading ? (
          <Spinner styles={style} />
        ) : (
          <div className="card-content d-flex justify-content-between align-items-end" title={name}>
            <div className="text">
              <p className="mb-0 number">{numberOfMembers}</p>
              <p className="mb-0 card-h">{name}</p>
            </div>
            <div className="event-avtars">
              <AvatarGroup max={4} className="MuiAvatar-fallback">
                {membersData.map((avtar, index) => {
                  return (
                    <Avatar
                      alt={avtar.name}
                      src={avtar.avtar ? avtar.avtar : avtar.first}
                      title={avtar?.first + " " + avtar?.last}
                      className={
                        index == 0
                          ? "IndexZero"
                          : index == 1
                            ? "IndexOne"
                            : index == 2
                              ? "IndexTwo"
                              : index == 3
                                ? "IndexThree"
                                : index == 4
                                  ? "IndexFour"
                                  : ""
                      }
                    >
                      {(
                        avtar.first?.[0] + avtar.last?.[0]
                      )?.toString()?.toUpperCase()}
                    </Avatar>
                  );
                })}
              </AvatarGroup>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventCard;
